<template>
  <div
    v-if="auth.isAuthenticated"
    class="admin-layout"
    :class="{ 'sidebar-open': isSidebarOpen }"
  >
    <AdminSidebar />
    <div class="main-content">
      <AdminTopbar @toggle-sidebar="openSidebar" />
      <div class="content-wrapper">
        <router-view />
      </div>
    </div>

    <div
      v-if="isSidebarOpen"
      class="sidebar-overlay"
      @click="closeSidebar"
    ></div>
  </div>

  <div v-else class="login-layout">
    <router-view />
  </div>
</template>

<script setup>
import { ref } from "vue"; // [GEMINI EDIT] - Import ref
import { useAdminAuthStore } from "@/stores/adminAuthStore";
import AdminSidebar from "@/components/AdminSidebar.vue";
import AdminTopbar from "@/components/AdminTopbar.vue";

const authStore = useAdminAuthStore();
const auth = authStore;

// --- [GEMINI EDIT] - เพิ่ม State และ Functions สำหรับ Sidebar ---
const isSidebarOpen = ref(false); // (ค่าเริ่มต้น: ปิด)

const openSidebar = () => {
  isSidebarOpen.value = true;
};
const closeSidebar = () => {
  isSidebarOpen.value = false;
};
// --------------------------------------------------------
</script>

<style>
/* (CSS Global เดิม) */
@import url("https://fonts.googleapis.com/css2?family=Kanit:wght@400;500;700&display=swap");
body {
  background-color: #f4f7f6;
  margin: 0;
  font-family: "Kanit", sans-serif;
}
.admin-layout {
  display: flex;
}
.main-content {
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}
.content-wrapper {
  padding: 20px;
  background-color: #f4f7f6;
  flex-grow: 1;
}
.login-layout {
  height: 100%;
}

/* --- [GEMINI EDIT] - เพิ่ม CSS สำหรับ Overlay และ Responsive --- */
.sidebar-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5); /* (พื้นหลังสีดำโปร่งแสง) */
  z-index: 999; /* (z-index ต้อง "ต่ำกว่า" Sidebar (1000)) */
}

/* (CSS นี้จะทำงานเฉพาะจอเล็ก) */
@media (max-width: 992px) {
  /* (ในโหมดมือถือ main-content จะกว้างเต็มจอเสมอ
     เพราะ Sidebar จะลอยอยู่)
  */
  .admin-layout {
    flex-direction: column;
  }
  .main-content {
    width: 100%;
  }
}
</style>
